import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CopyDayModalPage } from './copy-day-modal.page';

const routes: Routes = [
  {
    path: '',
    component: CopyDayModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CopyDayModalPageRoutingModule {}
